import {View, Image, Text} from '@react-pdf/renderer';

import {CultureType} from '../../../../../culture/dashboard/types/CultureInformationTypes';
import {cultureTypeOverviewStyles as styles} from '../../styles/culture-type-overview';
import {sharedStyles} from '../../styles/shared-styles';

interface Props {
  cultureData?: CultureType;
  currentLanguage: 'en' | 'de';
}

export const PdfCultureTypeDescription = ({cultureData, currentLanguage}: Props) => {
  const words = cultureData?.keywords && cultureData?.keywords[currentLanguage].split(',').map((str) => str.trim());

  const renderKeywords = () => {
    if (!words) {
      return null;
    }

    return (
      <View style={styles.cultureTypeKeywordsContainer}>
        {words.map((word, index) => (
          <View style={styles.keyWordBox} key={`${word} ${index}`}>
            <Text style={sharedStyles.body1}>{word}</Text>
          </View>
        ))}
      </View>
    );
  };

  return (
    <View style={styles.cultureTypeDetailsContainer}>
      <View style={styles.cultureTypeImageContainer}>
        <Image
          src={{uri: cultureData?.imageUrl || '', method: 'GET', headers: {'Cache-Control': 'no-cache'}, body: ''}}
          style={styles.cultureTypeImage}
        />
      </View>
      <View style={styles.cultureTypeTextContainer}>
        <Text style={{...sharedStyles.h3, marginBottom: 5}}>{cultureData?.name[currentLanguage]}</Text>
        <Text style={{...sharedStyles.h4, fontWeight: 400, lineHeight: '1.5px'}}>
          {cultureData?.description.paragraphOne[currentLanguage]}
        </Text>
        {renderKeywords()}
      </View>
    </View>
  );
};
